function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentMethodMobileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.16 3.83h10.368c.573 0 1.037.465 1.037 1.038v1.036H4.124v2.074h12.441v2.851c.664-.259 1.357-.458 2.074-.59V4.869a3.11 3.11 0 00-3.11-3.11H5.16a3.11 3.11 0 00-3.11 3.11v20.736a3.11 3.11 0 003.11 3.11h6.755a11.423 11.423 0 01-1.364-2.073h-5.39a1.037 1.037 0 01-1.037-1.037V4.868c0-.573.464-1.037 1.036-1.037z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.354 22.493h-5.23v2.074h5.613a11.362 11.362 0 01-.383-2.074zM17.295 23.184v1.576h2.43v1.88h2.008v-1.866h2.39v-1.59h-2.39v-.919h2.39v-1.59h-1.459l2.196-4.402h-2.223l-1.86 4.402-1.822-4.402h-2.39l2.203 4.402h-1.473v1.59h2.403v.92h-2.403z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.565 13.095a9.331 9.331 0 102.074-.739 9.261 9.261 0 00-2.074.74zm4.148 15.62a7.258 7.258 0 100-14.516 7.258 7.258 0 000 14.515z",
    fill: props.color
  }));
}

export default SvgIconPaymentMethodMobileOutline;